import React, { Component } from 'react';
import { Card, CardBody,Table, Row, Col } from "reactstrap";

//Componentes auxiliares:
import DownloadSourceResumeRow from './auxiliars/DownloadSourceResumeRow';

//Variables auxiliares:
let columnsList = [
    {
        title: "Fuente de descarga",
        key: "description",
        // style: { textAlign: "center", width: 70 }
    },
    {
        title: "Estado",
        key: "status",
        // style: { textAlign: "center", width: 70 }
    },
    {
        title: "última descarga",
        key: "modified",
        // style: { textAlign: "center", width: 70 }
    },
    {
        title: "próxima descarga",
        key: "next_execution_date",
        // style: { textAlign: "center", width: 70 }
    }
];

class DownloadSourcesResumeTable extends Component {

    constructor() {
        super();

        this.state = {
            activeSortKey: "",
            activeQuantity: 5,
            downloadSources: [],
            activeSortDirection: ""
        }
    }

    componentDidMount() {
        let adjustedDownloadSourcesList = [];

        for (let i = 0; i < this.props.downloadSources.length; i++) {
            adjustedDownloadSourcesList.push({
                ...this.props.downloadSources[i],
                nextDownloadDate: (this.props.downloadSources[i].nextDownload) ? (this.props.downloadSources[i].nextDownload.date) : "",
                lastDownloadStatus: this.props.getDownloadSourceTitle(this.props.downloadSources[i])
            });
        }

        this.setState({ downloadSources: adjustedDownloadSourcesList });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.downloadSources !== prevProps.downloadSources) {
            this.setState({ downloadSources: this.props.downloadSources });
        }
    }

    render() {
        return (
            <Row>
                <Col md="12">
                    <Card>
                        <CardBody>
                            <div className="card-without-scrollbar">
                                <Table >
                                    {this.getTableHeader()}
                                    <tbody>
                                        {this.getTableRows()}
                                    </tbody>
                                </Table>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }

    //Métodos operativos:
    sortSourcesBasedOnKey = (key) => {

        if (key !== this.state.activeSortKey) {
            this.setState({
                activeSortKey: key, activeSortDirection: "asc"
            });
        }
        else {
            if (this.state.activeSortDirection !== "asc") {
                this.setState({
                    activeSortKey: key, activeSortDirection: "asc"
                });
            }
            else {
                this.setState({ activeSortKey: key, activeSortDirection: "des" });
            }
        }
    }

    //Métodos para renderizado:
    getTableHeader = () => {
        let headersList = [];
        let sortIcon = undefined;

        for (let i = 0; i < columnsList.length; i++) {
            if (columnsList[i].key === this.state.activeSortKey) {
                if (this.state.activeSortDirection === "asc") {
                    sortIcon = <span><i className={"nc-icon nc-minimal-down"} style={{ marginLeft: 4 }}></i></span>;
                }
                else {
                    sortIcon = <span><i className={"nc-icon nc-minimal-up"} style={{ marginLeft: 4 }}></i></span>;
                }
            }
            else {
                sortIcon = null;
            }

            headersList.push(
                <th style={{ ...columnsList[i].style, fontSize: 10 }} key={"encabezadoDeFuentes." + i}>
                    <p style={{ marginBottom: 0, cursor: "pointer" }} onClick={() => {
                        this.sortSourcesBasedOnKey(columnsList[i].key)
                    }}>
                        {columnsList[i].title}
                        {sortIcon}
                    </p>
                </th>
            );
        }

        return (
            <thead className="muted-text">
                <tr>
                    {headersList}
                </tr>
            </thead>
        );
    }

    getTableRows = () => {
        let rowsList = [];

        let sortedDownloadSources = [];

        if (this.props.downloadSources.length > 0 && this.state.activeSortKey === "") {
            sortedDownloadSources = this.props.downloadSources.sort((a, b) => a.id > b.id ? 1 : b.id > a.id ? -1 : 0);
        }
        else if (this.state.activeSortKey !== "") {
            let key = this.state.activeSortKey;
            let sortingDirection = this.state.activeSortDirection;

            if (sortingDirection === "asc") {
                sortedDownloadSources = this.props.downloadSources.sort((a, b) => a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0);
            }
            else {
                sortedDownloadSources = this.props.downloadSources.sort((a, b) => a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0);
            }
        }

        for (let i = 0; i < sortedDownloadSources.length; i++) {
            rowsList.push(
                <DownloadSourceResumeRow key={"downloadSource." + this.state.activeSortKey + "." + i}
                    downloadSource={sortedDownloadSources[i]}
                    cancelDownloadProcess={this.props.cancelDownloadProcess}
                    retryDownloadProcess={this.props.retryDownloadProcess}
                    executeScratchOnClick={this.props.executeScratchOnClick}
                    getScratchUrl={this.props.getScratchUrl}
                    getStatusButtonClassname={this.props.getStatusButtonClassname}
                    getStatusIconClassname={this.props.getStatusIconClassname}
                    getDownloadSourceTitle={this.props.getDownloadSourceTitle}
                    getTimelineDivClassname={this.props.getTimelineDivClassname}
                    getTimelineIconClassname={this.props.getTimelineIconClassname}
                    reloadSourcesMethod={this.props.reloadSourcesMethod} />
            );
        }
        return rowsList;
    }
}

export default DownloadSourcesResumeTable;